"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_string_1 = __importDefault(require("query-string"));
exports.isObject = function (obj) {
    return obj && typeof obj === 'object' && !Array.isArray(obj);
};
exports.getObjectKeys = function (obj) { return (exports.isObject(obj) ? Object.keys(obj) : []); };
exports.viewsForDirector = function (views, store, config) {
    return exports.getObjectKeys(views).reduce(function (obj, viewKey) {
        var view = views[viewKey];
        obj[view.path] = function () {
            var paramsArr = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                paramsArr[_i] = arguments[_i];
            }
            var paramsObject = paramsArr
                ? view.getParamsObject(paramsArr)
                : undefined;
            var queryParamsObject;
            if (config.html5history === false) {
                // hash routing (query parameter not stored in location.search)
                var m = window.location.hash.match(/\?.*$/);
                if (m) {
                    queryParamsObject = query_string_1.default.parse(m[0]);
                }
            }
            else {
                queryParamsObject = query_string_1.default.parse(window.location.search);
            }
            store.router.goTo(view, paramsObject || {}, queryParamsObject);
        };
        return obj;
    }, {});
};
exports.getRegexMatches = function (string, regexExpression, callback) {
    var match;
    while ((match = regexExpression.exec(string)) !== null) {
        callback(match);
    }
};
//# sourceMappingURL=utils.js.map